import { CircularProgress } from "@material-ui/core";
import React, { useMemo } from "react";

import { Container } from "./styles";

function Loading({ color, newLoading = false, isRocketTrader = false }) {
	const setLoading = useMemo(() => {
		if (newLoading) {
			return (
				<svg
					width="80"
					height="82"
					viewBox="0 0 80 82"
					fill="#23242f"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path d="M48.5169 52.39C48.5169 52.39 59.8228 47.2141 71.5442 52.2101C71.6588 52.2682 71.7877 52.2914 71.9151 52.2767C72.0425 52.2621 72.1628 52.2102 72.2615 52.1275C72.3602 52.0448 72.4329 51.9349 72.4707 51.8111C72.5084 51.6874 72.5097 51.5552 72.4742 51.4307C70.8515 44.8227 62.5799 15.4928 41.1687 2.13679C41.0472 2.04309 40.8974 1.9949 40.7446 2.00043C40.5919 2.00596 40.4457 2.06487 40.3313 2.16713C40.2168 2.26938 40.141 2.40862 40.1169 2.56104C40.0928 2.71345 40.1218 2.86959 40.199 3.00278C43.4048 9.62415 52.6461 31.127 48.5169 52.39Z" />
					<path d="M58.8256 64.0743C50.4762 62.5933 41.8828 64.4158 34.8287 69.1636C41.1083 43.1377 31.867 20.5358 31.6559 20.0562C26.1415 15.2667 17.8039 9.49131 7.39511 6.56698C7.24942 6.51074 7.08867 6.50846 6.94147 6.56054C6.79426 6.61262 6.67013 6.71569 6.59104 6.85146C6.51196 6.98723 6.48311 7.14691 6.50956 7.30215C6.536 7.45739 6.61603 7.59814 6.7355 7.69942C13.9913 14.7138 37.81 41.8521 20.0003 82C20.0003 82 41.6359 64.6805 60.1118 78.0032C60.215 78.0909 60.3425 78.1445 60.4769 78.1568C60.6112 78.1691 60.746 78.1395 60.8632 78.072C60.9804 78.0045 61.0743 77.9023 61.1321 77.7792C61.19 77.6561 61.2093 77.5181 61.1871 77.3837C60.8243 74.7392 60.0129 69.1503 58.8256 64.0743Z" />
					<path d="M64.645 51.4311C53.2006 50.3986 46.0832 55.5678 46.0832 55.5678C50.8193 33.9517 44.6915 18.7505 44.6651 18.6973C39.5332 13.7878 31.9146 7.16648 25.8659 4.70844C25.7303 4.63258 25.5727 4.60737 25.4205 4.63723C25.2683 4.66709 25.1314 4.75009 25.0338 4.8717C24.9362 4.99331 24.8842 5.14575 24.8868 5.30227C24.8894 5.45878 24.9464 5.60938 25.048 5.72763C29.4609 11.5829 42.3564 31.94 38.0161 65.2067C38.0161 65.2067 52.5276 57.2598 67.158 65.8729C67.2652 65.9449 67.3911 65.9837 67.5199 65.9845C67.6486 65.9852 67.7748 65.9479 67.8828 65.877C67.9909 65.8062 68.0759 65.705 68.1276 65.5859C68.1793 65.4668 68.1954 65.335 68.1738 65.2067C67.5296 60.4924 66.3455 55.8695 64.645 51.4311Z" />
					<path
						d="M7 6.5L13 14C31 37 29.5 55.5 20.5 81C37.0802 69.4281 45.993 70.5986 61.5 78C61.1998 69.6589 60.4576 67.5873 59 64.5C57.5 61.5 63.5527 63.6323 68 66L64.5 52C63.5 48.5 68.7677 50.145 72.5 52C64.0121 28.9674 60.2339 15.2817 40 1.5C44 8.5 47 15.5 44.5 18C37.5869 10.8824 33.2406 7.8589 24.5 4.5C29.2115 11.1515 32 18 31 19.5C31 19.5 17.2703 8.94701 7 6.5Z"
						className="st1 caravel"
					/>
				</svg>
			);
		}

		if (isRocketTrader) {
			return (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="84"
					height="84"
					viewBox="0 0 100 100"
					preserveAspectRatio="xMidYMid"
				>
					<path
						d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50"
						fill="#1da1f2"
						stroke="none"
					>
						<animateTransform
							attributeName="transform"
							type="rotate"
							dur="1s"
							repeatCount="indefinite"
							keyTimes="0;1"
							values="0 50 51;360 50 51"
						></animateTransform>
					</path>
				</svg>
			);
		}

		return <CircularProgress style={{ color: color ? color : "#04a4b0" }} />;
	}, [color, newLoading, isRocketTrader]);

	return <Container>{setLoading}</Container>;
}

export default Loading;
